// 手机号码
// eslint-disable-next-line no-useless-escape
export const isMobile = str => /^[0-9\+\-\(\)]{9,20}$/.test(str)

// 是否是 数字
export const isNumber = val => {
  const regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  const regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  return !!(regPos.test(val) || regNeg.test(val))
}

// 是否是 银行卡号
export const isAccountNo = val => /^[0-9]{8,12}$/.test(val)

// ID规则
export const isIdentity = val => /(^(?![^A-Z]+$)(?!\D+$)[A-Z0-9]{8,9}$)|(^[0-9]{10}$)/

/**
 * @description 判断是否是有效链接
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @description 判断用户
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const validMap = ['admin', 'editor']
  return validMap.indexOf(str.trim()) >= 0
}
